export const ActionTypes = 
{
    CHANGE_THEME : "CHANGE_THEME",
    CHANGE_VIEW : "CHANGE_VIEW"
}